import { TASK_STATUS } from '../workflow/task-status';
// ---------------------------------------------------------------------------------------------
// Operational dashboard (package 7b) — Manager and Team Lead
// ---------------------------------------------------------------------------------------------
/**
 * How wide the operational dashboard's numbers reach.
 *
 * Named rather than implied because every card on the screen is a promise that the number and the
 * list it opens are the same rows, and the list can only reproduce a scope it has a view for.
 * `taskListView` is that view: `team` selects the lead's teams, `all` the whole organization.
 */
export const OPERATIONS_SCOPE = {
    /** Super Admin and Project Manager: every active project in the organization. */
    ORGANIZATION: 'organization',
    /** Team Lead: the projects they manage, lead or belong to, and the people in their teams. */
    TEAM: 'team',
};
/**
 * The statuses behind each state-shaped Today card.
 *
 * Shared rather than written out on both sides, because the API counts these and the web app
 * links to a task list filtered by them; two copies would let a card open a different set from
 * the one it counted the first time a status was added to the pipeline.
 */
export const OPERATIONS_TODAY_STATUSES = {
    blocked: [TASK_STATUS.BLOCKED],
    returnedToDeveloper: [TASK_STATUS.RETURNED_TO_DEV],
    waitingForReview: [TASK_STATUS.IN_REVIEW, TASK_STATUS.CODE_REVIEW],
    waitingForQa: [TASK_STATUS.READY_FOR_QA, TASK_STATUS.TESTING_STAGING],
};
/** The statuses each "waiting for somebody else" column of the project grid counts. */
export const OPERATIONS_PROJECT_STATUSES = {
    pendingQa: [TASK_STATUS.READY_FOR_QA, TASK_STATUS.TESTING_STAGING],
    pendingUat: [TASK_STATUS.CLIENT_UAT],
    pendingRelease: [TASK_STATUS.QA_PASSED, TASK_STATUS.READY_TO_PUBLISH],
};
//# sourceMappingURL=dashboards.js.map